import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.messagesElement = this.element
    this.boundHandleScroll = () => this.captureUserScrollIntent()
    this.messagesElement.addEventListener("scroll", this.boundHandleScroll, { passive: true })
    this.userPinnedToBottom = true
    this.observer = new MutationObserver(() => this.handleMutation())
    this.observer.observe(this.messagesElement, { childList: true, subtree: true })
    this.scrollToBottom(true)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    if (this.messagesElement && this.boundHandleScroll) {
      this.messagesElement.removeEventListener("scroll", this.boundHandleScroll)
    }
  }

  handleMutation() {
    if (!this.messagesElement) return
    this.ensureChronologicalOrder()

    if (this.userPinnedToBottom) {
      this.scrollToBottom()
    }
  }

  captureUserScrollIntent() {
    if (!this.messagesElement) return
    this.userPinnedToBottom = this.isNearBottom()
  }

  isNearBottom() {
    if (!this.messagesElement) return true

    const threshold = 72
    const distanceFromBottom = this.messagesElement.scrollHeight - (this.messagesElement.scrollTop + this.messagesElement.clientHeight)
    return distanceFromBottom <= threshold
  }

  scrollToBottom(force = false) {
    if (!this.messagesElement) return
    if (!force && !this.userPinnedToBottom) return

    this.messagesElement.scrollTop = this.messagesElement.scrollHeight
    this.userPinnedToBottom = true
  }

  ensureChronologicalOrder() {
    if (!this.messagesElement) return

    const messageNodes = Array.from(this.messagesElement.querySelectorAll(":scope > .message"))
    if (messageNodes.length < 2) return

    const sorted = messageNodes
      .map((node, index) => ({ node, index }))
      .sort((left, right) => {
        const leftId = Number.parseInt(left.node.dataset.messageId || "", 10)
        const rightId = Number.parseInt(right.node.dataset.messageId || "", 10)
        const leftRank = Number.isFinite(leftId) ? leftId : Number.MAX_SAFE_INTEGER
        const rightRank = Number.isFinite(rightId) ? rightId : Number.MAX_SAFE_INTEGER

        if (leftRank === rightRank) return left.index - right.index
        return leftRank - rightRank
      })
      .map((entry) => entry.node)

    const alreadySorted = sorted.every((node, index) => node === messageNodes[index])
    if (alreadySorted) return

    sorted.forEach((node) => this.messagesElement.appendChild(node))
  }
}
